import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAward, } from '@fortawesome/free-solid-svg-icons'

const StepCard = () => {
    return (
        <div className="card bg-white full-width px-4 py-3" style={{borderBottom:'2px solid #e9ecf2 !important'}} >
          <div className="d-flex">
            <div className="d-flex">
              <div className="d-flex jc-center ai-center" style={{background: '#e9ecf2', height:55, width: 55, borderRadius:12,}}>
                <FontAwesomeIcon icon={faAward}  style={{ height:30, color:'#08090a'}} />
              </div>
              <div className="d-flex flex-col ml-5 jc-center" style={{marginLeft:20}}>
                <span className="madeGentle" style={{fontSize:18, lineHeight:1.5}}>Complete Your Profile</span>
                <span>Apply To Be Eligible For Campaigns</span>
              </div>
            </div>
          </div>
        </div>
    )
};

export default StepCard;